<h2>404 Siden findes ikke!</h2>
<a [routerLink]="'/aftale'">Tryk her for at gå til forsiden</a>
